import { fetchModel } from "@Services/article";
import { fetchNewCarBrands } from "@Services/buyCar";
import { ICarDetails } from "@Types/common";
import { useQuery } from "react-query";
import { EBrandSelectType } from "@Types/constants";
import { ArrowRightIcon } from "@t8891/icon";
import { useSetState, useClickAway, useMount, useScroll } from "ahooks";
import React, { useEffect, useRef, useState } from "react";

interface KindSelectProps {
  onChange?: (key: "index" | "brand" | "kind" | "model", data: any, allData?: any) => void;
  open: boolean;
  setOpen: (status: boolean) => void;
  className?: string;
}
interface IData {
  /** 字母标签 */
  label: string;
  /** 列表 */
  list: ICarDetails[];
}

const ModelSelect: React.FC<KindSelectProps> = ({ onChange, open, className, setOpen }) => {
  const brandRef = useRef<any>(null);
  const selectRef = useRef<any>(null);
  const [data, setData] = useState<IData[]>();
  const [visible, setVisible] = useState(false);
  const [listIndex, setListIndex] = useState<number[]>([]);
  const scroll = useScroll(brandRef);
  const [selectInfo, setSelectInfo] = useSetState({
    index: "A",
    selectBrand: {} as any,
    selectKind: {} as any,
    selectModel: {} as any,
  });

  const initData = {};
  const { data: modelData = initData, refetch } = useQuery<any>(
    [`fetchModelbase`, selectInfo.selectKind.id],
    async () => {
      const res = await fetchModel({ type: "base", k: selectInfo.selectKind.id });

      if (res?.status === 12000) {
        return res.data;
      }
      return initData;
    },
    {
      enabled: false,
    },
  );

  useEffect(() => {
    if (!!selectInfo.selectKind.id) {
      refetch();
    }
  }, [selectInfo.selectKind.id]);

  /** 获取厂牌车款 */
  const getKinds = async () => {
    const res = await fetchNewCarBrands({ hasKind: 1 });

    if (res.status === 12000) {
      setData(res.data?.brand);
    }
  };
  // 选中字母
  const handleClickLetter = (letter) => {
    setSelectInfo({ index: letter });
    onChange?.("index", letter);
    const clickDom = document.getElementById(`brands-select-${letter}`);
    if (clickDom && brandRef?.current) {
      brandRef?.current?.scrollTo?.(0, clickDom?.offsetTop);
    }
  };

  // 选中厂牌
  const handleClickBrand = (brandItem) => {
    setSelectInfo({ selectBrand: brandItem });
    onChange?.("brand", brandItem, selectInfo);
  };

  // 选中车款
  const handleClickKind = (kindItem) => {
    setSelectInfo({ selectKind: kindItem });
    onChange?.("kind", kindItem, selectInfo);
  };

  // 选中車型
  const handleClickModel = (modelItem) => {
    setSelectInfo({ selectModel: modelItem });
    onChange?.("model", modelItem, { ...selectInfo, selectModel: modelItem });
  };

  useMount(() => {
    getKinds();
  });

  useEffect(() => {
    setVisible(open);
  }, [open]);

  useClickAway(() => {
    setVisible(false);
    setOpen(false);
  }, selectRef);

  // 更新INDEX序号
  useEffect(() => {
    const { top } = (scroll as { top: number }) || {};
    const idx = listIndex.findIndex((i, index) => {
      return listIndex[index + 1] && top > listIndex[index] && top < listIndex[index + 1];
    });
    if (idx > -1) {
      setSelectInfo({ index: data?.[idx].label });
    }

    // 更新厂牌对应序号
    if (listIndex.length) return;
    const tmp = [] as number[];
    data?.forEach((i) => {
      const clickDom = document.getElementById(`brands-select-${i.label}`);
      if (clickDom) {
        tmp.push(clickDom?.offsetTop);
      }
    });
    setListIndex(tmp);
  }, [scroll]);

  if (!visible || !data?.length) {
    return <></>;
  }

  return (
    <div className={`flex ${className}`} ref={selectRef}>
      {/* 字母序列 */}
      <div className='w-24 h-532 flex flex-col bg-[#E8E8E8] text-14 font-normal text-[#666] items-center  cursor-pointer'>
        {data?.map((item) => {
          return (
            <div
              className={`w-24 h-24 leading-24 text-center ${
                item.label === selectInfo.index ? "bg-[#406EFF] rounded-4 text-[#fff]" : ""
              }`}
              key={item.label}
              onClick={() => {
                handleClickLetter(item.label);
              }}
            >
              {item.label}
            </div>
          );
        })}
      </div>
      {/* 厂牌 */}
      <div className='w-208 h-532 overflow-scroll' ref={brandRef}>
        {data?.map((item) => {
          return (
            <>
              <div
                className='w-full h-32 bg-[#f5f5f5] leading-32 pl-16 cursor-pointer text-left text-14 text-[#333]'
                key={item.label}
                id={`brands-select-${item.label}`}
              >
                {item.label}
              </div>
              {item.list?.map((brandItem) => {
                return (
                  <div
                    className={`w-full flex items-center justify-between h-32 leading-32  pl-16 pr-10 text-left text-14 text-[#333] font-normal cursor-pointer ${
                      selectInfo.selectBrand?.id === brandItem.id ? "bg-[#3264ff] text-[#fff]" : "bg-[#fff] text-[#333]"
                    }`}
                    key={brandItem.id}
                    onClick={() => {
                      handleClickBrand(brandItem);
                    }}
                  >
                    <div className='flex-1 text-ellipsis'>{brandItem?.name}</div>
                    <ArrowRightIcon size={12} fill={selectInfo.selectBrand?.id === brandItem.id ? "#fff" : "#bbb"} />
                  </div>
                );
              })}
            </>
          );
        })}
      </div>
      {selectInfo?.selectBrand?.id && (
        <div className='w-208  h-532 overflow-scroll bg-[#fff]'>
          <div className='w-full flex items-center justify-between h-32 leading-32 bg-[#fff] pl-16 pr-10 text-left text-14 text-[#333] font-normal cursor-pointer'>
            全部車款
          </div>
          {selectInfo?.selectBrand?.children?.map((kindItem) => {
            return (
              <div
                key={kindItem.id}
                className={`w-full flex items-center justify-between h-32 leading-32  pl-16 pr-10 text-left text-14 text-[#333] font-normal 
                cursor-pointer ${
                  selectInfo.selectKind?.id === kindItem.id ? "bg-[#3264ff] text-[#fff]" : "bg-[#fff] text-[#333]"
                }`}
                // className={`w-full h-32 leading-32 pl-16 pr-10 text-left text-14 font-normal cursor-pointer ${selectInfo.selectKind.id === kindItem.id ? "bg-[#3264ff] text-[#fff]" : " bg-[#fff] text-[#333] "
                //   }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClickKind(kindItem);
                }}
              >
                {kindItem.name}
                <ArrowRightIcon size={12} fill={selectInfo.selectBrand?.id === kindItem.id ? "#fff" : "#bbb"} />
              </div>
            );
          })}
        </div>
      )}
      {!!selectInfo?.selectKind?.id && (
        <div className='min-w-200 h-532 overflow-scroll bg-[#fff]'>
          <div className='w-full flex items-center justify-between h-32 leading-32 bg-[#fff] pl-16 pr-10 text-left text-14 text-[#333] font-normal cursor-pointer'>
            全部車型
          </div>
          {modelData?.list?.map((modelItem) => {
            return (
              <div
                key={modelItem.myid}
                className={`w-full h-32 leading-32 pl-16 pr-10 text-left text-14 font-normal cursor-pointer  whitespace-pre
                ${
                  selectInfo.selectModel.myid === modelItem.myid
                    ? "bg-[#3264ff] text-[#fff]"
                    : " bg-[#fff] text-[#333] "
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClickModel(modelItem);
                }}
              >
                {modelItem.modelName}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ModelSelect;
